import { Helmet } from 'react-helmet-async'
import { useIntl } from 'react-intl'
import { useCMSContentQuery } from '@mwxltd/flix-api-client'
import { CMSSectionList } from '@flix/common/domain/cms'
import { FillScreen } from '../../../components/layout/FillScreen/FillScreen'
import { canonicalUrl } from '../../../utils/htmlHead'
import UnexpectedErrorPage from '../../error/UnexpectedErrorPage'
import meta from '../../metaDescriptions'

// Transparent header configured in `useNavBarTransparency.js`
const AboutPage = () => {
  const intl = useIntl()
  const { data, error } = useCMSContentQuery('about')
  return (
    <>
      <Helmet>
        <title>{intl.formatMessage(meta.aboutTitle)}</title>
        <meta
          name="description"
          property="og:description"
          content={intl.formatMessage(meta.about)}
        />
        <meta property="og:url" content={canonicalUrl('/about')} />
        <link rel="canonical" href={canonicalUrl('/about')} />
      </Helmet>

      {error ? (
        <UnexpectedErrorPage />
      ) : (
        <FillScreen>
          <CMSSectionList sections={data?.sections} />
        </FillScreen>
      )}
    </>
  )
}

export default AboutPage
